/**
 * Try to make it work with jq droppable
 *
 * https://stackoverflow.com/questions/19770067/drop-draggable-on-droppable-programmatically-and-trigger-drop
 */


(function ( $ ) {
    $.fn.customDraggable = function(params) {
        $.each(this, function() {
            const elm = $(this);

            // refreshPositions ??

            const start = (event) => {
                if (!elm.hasClass('holding')) {
                    elm.addClass('holding');


                }
            };

            const move = (event) => {
                if (elm.hasClass('holding')) {
                    event.preventDefault();

                    elm.addClass('moving');

                    if (!elm[0].dragItem) {
                        if (params.helper) {
                            const helper = params.helper.bind(this);
                            elm[0].dragItem = helper(event);

                            elm.css({opacity: .5});
                        } else {
                            elm[0].dragItem = elm;
                        }

                        elm[0].dragItem.css({
                            position: 'absolute',
                            left: event.x,
                            top: event.y,
                            // transition: 'all 60ms linear',
                            transform: 'translateX(-50%)'
                        });
                    }


                    elm[0].dragItem.css({
                        left: event.pageX,
                        top: event.pageY,
                    });

                    if (document.selection) {
                        document.selection.empty()
                    } else {
                        window.getSelection().removeAllRanges()
                    }

                    // Check droppables
                    $('.ui-droppable').each(function() {
                        const xFrom = $(this).offset().left;
                        const yFrom = $(this).offset().top;

                        const xTo = xFrom + $(this).width();
                        const yTo = yFrom + $(this).height();

                        if (event.pageX > xFrom && event.pageX < xTo && event.pageY > yFrom && event.pageY < yTo) {
                            $(this).addClass('ui-droppable-hover');
                        } else {
                            $(this).removeClass('ui-droppable-hover');
                        }
                    });

                    return false;
                }
                return true;
            };

            const end = (event) => {
                const droppable = $('.ui-droppable-hover:first');
                if (elm.hasClass('holding') && elm.hasClass('moving') && droppable.length > 0) {
                    droppable.trigger('drop', {draggable: elm, helper: elm[0].dragItem});
                }
                if (params.helper && elm[0].dragItem) {
                    elm[0].dragItem.remove();
                }
                $('.ui-droppable-hover').removeClass('.ui-droppable-hover');
                elm.removeClass('holding');
                elm.removeClass('moving');
                elm.css({opacity: 1});
            };


            elm[0].addEventListener('touchstart', function(event) {
                elm[0].holdingTimeout = setTimeout(() => {
                    start(event);
                }, 500);
            });
            elm[0].addEventListener('mousedown', start);

            document.addEventListener('touchmove', (event) => {
                move(event);
                clearTimeout(elm[0].holdingTimeout);
            }, { passive:false });
            document.addEventListener('mousemove', move);

            document.addEventListener('touchend', (event) => {
                end(event);
                clearTimeout(elm[0].holdingTimeout);
            });
            document.addEventListener('mouseup', end);

            // helper
            // drag
            // start
        });
        return this;
    };

}( jQuery ));
